import axios from '@axios'
import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSuppliers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/suppliers/', {params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    fetchSupplier(ctx,{id}) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`/suppliers/${id}`)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    editSupplier(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/suppliers', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteSupplier(ctx, queryParams) {
      return new Promise((resolve, reject) => {
         axiosIns.delete('/suppliers', { params: queryParams })
         .then(response=>resolve(response))
         .catch(error=>reject(error))
      })
    },
    exportSuppliers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/suppliers/export', { params: queryParams, responseType: "blob" })
        .then(response=>resolve(response))
        .catch(error=>reject(error))
      })
    },
    fetchSupplierDocuments(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/suppliers/documents/list', {params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    fetchAllSupplierDocuments(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/suppliers/documents/all', {params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    fetchSupplierDocumentDetail(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`/suppliers/documents/${id}`)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },

    approveSupplier(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/suppliers/documents/approve", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteSupplierDocument(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.delete('/suppliers/documents', { params: queryParams })
        .then(response=>resolve(response))
        .catch(error=>reject(error))
      })
    },
    exportSupplierDocuments(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/suppliers/documents/export', {
          params: queryParams,
          responseType: 'blob'
        })
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    // 獲取下一個付款憑證編號
    getNextPaymentProofNumber(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/suppliers/documents/payment-proof/next-number")
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // 驗證付款憑證編號唯一性
    validatePaymentProofNumber(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/suppliers/documents/payment-proof/validate-number", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // 獲取下一個付款收據編號
    getNextPaymentReceiptNumber(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/suppliers/documents/payment-receipt/next-number")
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // 驗證付款收據編號唯一性（使用 receipt_number）
    validatePaymentReceiptNumber(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/suppliers/documents/payment-receipt/validate-number", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    // 多筆付款憑證相關 API
    // 上傳多筆付款憑證
    uploadMultiplePaymentProofs(ctx, formData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/suppliers/payment-proofs-multiple", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // 獲取下一個付款憑證編號（新版本）
    getNextMultiplePaymentProofNumber(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/suppliers/payment-proofs/next-number")
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // 驗證付款憑證編號唯一性（新版本）
    validateMultiplePaymentProofNumber(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/suppliers/payment-proofs/validate-number", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // 刪除付款憑證
    deletePaymentProof(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/suppliers/payment-proofs", { data })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // 刪除帳單文件（僅刪除文件，保留記錄）
    deleteSupplierBillFiles(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/suppliers/documents/bills/files", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // 刪除付款憑證記錄（完全刪除）
    deleteSupplierPaymentProof(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/suppliers/documents/payment-proofs/destroy", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // 刪除付款收據記錄（完全刪除）
    deleteSupplierPaymentReceipt(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/suppliers/documents/payment-receipts/destroy", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
}
